import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.06071 7.99984L12.0295 5.03109C12.1704 4.89044 12.2496 4.69958 12.2498 4.5005C12.25 4.30142 12.171 4.11042 12.0304 3.96952C11.8897 3.82863 11.6989 3.74937 11.4998 3.7492C11.3007 3.74902 11.1097 3.82794 10.9688 3.96859L8.00008 6.93734L5.03133 3.96859C4.89043 3.82769 4.69934 3.74854 4.50008 3.74854C4.30082 3.74854 4.10973 3.82769 3.96883 3.96859C3.82793 4.10948 3.74878 4.30058 3.74878 4.49984C3.74878 4.69909 3.82793 4.89019 3.96883 5.03109L6.93758 7.99984L3.96883 10.9686C3.82793 11.1095 3.74878 11.3006 3.74878 11.4998C3.74878 11.6991 3.82793 11.8902 3.96883 12.0311C4.10973 12.172 4.30082 12.2511 4.50008 12.2511C4.69934 12.2511 4.89043 12.172 5.03133 12.0311L8.00008 9.06234L10.9688 12.0311C11.1097 12.172 11.3008 12.2511 11.5001 12.2511C11.6993 12.2511 11.8904 12.172 12.0313 12.0311C12.1722 11.8902 12.2514 11.6991 12.2514 11.4998C12.2514 11.3006 12.1722 11.1095 12.0313 10.9686L9.06071 7.99984Z",
		fill: "#70768D"
	})
});
export default SvgCloseFilled;
